import React, { Component } from 'react';
import {Link} from 'react-router-dom'
import Tippy from '@tippyjs/react';
import 'tippy.js/dist/tippy.css';
class SearchResults extends Component {
    state = { 
      showFileModal: false,
      showKey:""
     }
     showFiles = (item) => {
       let { searchResults } = this.props;
       searchResults.map(value=>{
         if(value.id == item.id){
          let { showFileModal, showKey } = this.state
          this.setState({
              showKey: item.id,
              showFileModal: !showFileModal
          })
         }
       })
     }
    render() { 
      let { searchResults } = this.props
      let { showFileModal, showKey } = this.state
       if(searchResults.length > 0){
        return ( 
          <div className="text-center md:text-left mt-4 relative ">
              <div className="absolute top-6  p-12 overflow-auto w-full h-56 bg-white rounded-md">
                 <span className="font-extrabold">Search Results</span>
                 <table className="divide-y mt-2 border-b border-gray-200 divide-gray-200"> 
                 <thead>
                   <tr className= "text-gray-500">
                      <th className="  px-4 py-3 whitespace-nowrap  text-sm font-medium  ">
                          Doc_ID
                      </th>
                      <th className="  px-4 py-3 whitespace-nowrap  text-sm font-medium  ">
                          Document Name
                      </th>
                      <th scope="col" className="  px-8 py-3 whitespace-nowrap  text-sm font-medium  ">
                          Collection
                      </th>
                      <th scope="col" className="  px-8 py-3 whitespace-nowrap  text-sm font-medium  ">
                         Community
                      </th>
                      <th scope="col" className="  px-8 py-3 whitespace-nowrap  text-sm font-medium  ">
                         Action
                      </th>


                  </tr>
              </thead>
              <tbody>                        
                  {
                    searchResults.map(result=>{
                      return(
                       <>
                        <tr key={result.id} onClick={() =>this.showFiles(result)}>
                          <td  className="  px-8 py-3 whitespace-nowrap  text-sm font-medium  ">
                            {result.doc_id}
                          </td>
                          <td  className="  px-8 py-3 whitespace-nowrap  text-sm font-medium  ">
                            {result.name}
                          </td>
                          <td  className="  px-8 py-3 whitespace-nowrap  text-sm font-medium  ">
                            {result.collection}
                          </td>
                          <td  className="  px-8 py-3 whitespace-nowrap  text-sm font-medium  ">
                            {result.community}
                          </td>
                          <td  className="  px-8 py-3 whitespace-nowrap  text-sm font-medium  ">
                            <a className="text-blue-700  font-semibold py-2 rounded-md" href={result.link} target="_blank">view document</a>
                          </td>
                      </tr> 
                       </> 
                
                      )
                    })
                  }                               
              </tbody>
                 </table>   
                        
               </div>
          </div>
        );
       }else{
         return (
           <div className="px-8 py-3 mt-8 bg-white">
              <div className="text-center text-red-600 font-bold">Your Search did not match any document</div>
           </div>
         )
       }
    }
}
 
export default SearchResults;